import { type S3Credentials } from '../../models/s3/s3-credentials';

// TODO: Add dto type or use the one provided by the backend

/** S3 credentials dto. */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type S3CredentialsDto = any;

export namespace S3UploadDataMapper {

  /**
   * Map temporary S3 credentials dto to S3 credentials model.
   * @param dto Temporary S3 credentials dto.
   */
  export function fromS3CredentialsDto(dto: S3CredentialsDto): S3Credentials {
    return {
      accessKeyId: dto.access_key_id,
      expiration: new Date(dto.expiration),
      secretAccessKey: dto.secret_access_key,
      sessionToken: dto.session_token,
    };
  }
}
